import {
  ButtonBase,
  Card,
  ClickAwayListener,
  makeStyles,
  MenuItem,
  Popper,
  Select,
  Typography,
  Button,
} from '@material-ui/core';
import { SearchBlock } from 'components/Common/SearchBlock';
import { get } from 'lodash';
import React from 'react';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

const useStyles = makeStyles((theme) => ({
  dropdown: {
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  popper: {
    zIndex: theme.zIndex.modal,
  },
}));

const DropDownCell = React.memo(
  ({ row, column, rowState, handleRowChange }) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const open = Boolean(anchorEl);

    React.useEffect(() => {
      handleRowChange(row.id, {
        [column.key]:
          (rowState || {})[column.key] || (row[column.key] || {}).value || null,
      });
    }, [row]);

    React.useEffect(() => {
      setMultiSelectCount(selectedCount(rowState[column.key]));
    }, [rowState]);

    const queryFunction = (searchString, searchResults, setList) => {
      if ((searchString || '').length !== 0) {
        let searchRegExp = new RegExp((searchString || '').toLowerCase());

        setList(
          (
            ((row || {})[column.key] || {}).selection ||
            column.selection ||
            []
          ).filter((item) =>
            searchRegExp.test((`${item.title}` || '').toLowerCase())
          )
        );
      } else {
        setList(
          ((row || {})[column.key] || {}).selection || column.selection || []
        );
      }
    };

    const checkSelected = (item) => {
      return !!(rowState[column.key] || []).find(
        (currentItem) => currentItem === item.id
      );
    };

    const multiSelect = get(
      column,
      ['columnContentType', 'multiSelect'],
      false
    );
    const selectedCount = (currentRow) => {
      return multiSelect
        ? currentRow.filter(
            (item) =>
              (
                ((row || {})[column.key] || {}).selection ||
                column.selection ||
                []
              ).find((currentItem) => currentItem.id === item) !== undefined
          ).length
        : 0;
    };
    const [multiSelectCount, setMultiSelectCount] = React.useState(
      selectedCount(rowState[column.key] || []) || 0
    );

    const checkSelectAll = () => {
      return (
        (rowState[column.key] || []).length ===
        (((row || {})[column.key] || {}).selection || column.selection || [])
          .length
      );
    };

    const selectAllHandle = () => {
      const newState = checkSelectAll()
        ? []
        : (
            ((row || {})[column.key] || {}).selection ||
            column.selection ||
            []
          ).map((item) => item.id);
      handleRowChange(row.id, {
        [column.key]: newState,
      });
      setMultiSelectCount(selectedCount(newState));
    };

    const onSelect = (selectedItem) => {
      const newState = multiSelect
        ? !!(rowState[column.key] || []).find(
            (item) => item === selectedItem.id
          )
          ? (rowState[column.key] || []).filter(
              (item) => item !== selectedItem.id
            )
          : [...(rowState[column.key] || []), selectedItem.id]
        : selectedItem.id;
      handleRowChange(row.id, { [column.key]: newState });
      if (!multiSelect) {
        setAnchorEl(null);
      } else {
        setMultiSelectCount(selectedCount(newState));
      }
    };

    return (
      <div>
        <div style={{ width: '100%', maxWidth: '100%' }}>
          <ButtonBase
            style={{
              width: '100%',
              height: '80%',
              maxWidth: '100%',
              textAlign: 'left',
            }}
          >
            <div
              onClick={(event) => setAnchorEl(event.currentTarget)}
              className={classes.borderedField}
              style={{
                ...(!!anchorEl
                  ? { borderColor: '#7467F0', borderWidth: 2 }
                  : {}),
                width: '100%',
                maxWidth: '100%',
                display: 'flex',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography
                style={{
                  width: '100%',
                  textAlign: 'left',
                  ...(!rowState[column.key]
                    ? { color: '#909090' }
                    : { color: '#505050' }),
                  fontSize: '1rem',
                  wordWrap: 'break-word',
                  whiteSpace: 'pre-wrap',
                  padding: '4px 0px 7px',
                }}
              >
                {multiSelect && multiSelectCount > 0
                  ? `${multiSelectCount} Selected`
                  : (
                      (
                        ((row || {})[column.key] || {}).selection ||
                        column.selection ||
                        []
                      ).find((item) => item.id === rowState[column.key]) || {}
                    ).title ||
                    column.hint ||
                    `Select ${column.title}`}
              </Typography>
              <KeyboardArrowDownIcon style={{ color: '#505050' }} />
            </div>
          </ButtonBase>
        </div>
        <Popper
          label={column.title}
          open={open}
          anchorEl={anchorEl}
          placement="bottom-start"
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          style={{
            width: '30vw',
          }}
          className={classes.popper}
        >
          <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
            <Card elevation={8}>
              <SearchBlock
                checkSelected={checkSelected}
                checkSelectAll={checkSelectAll}
                selectAllHandle={selectAllHandle}
                multiselect={multiSelect}
                onSelect={onSelect}
                selection={
                  ((row || {})[column.key] || {}).selection ||
                  column.selection ||
                  []
                }
                queryFunction={queryFunction}
              />
              {multiSelect && (
                <ButtonBase
                  style={{
                    width: '100%',
                    height: '80%',
                    maxWidth: '100%',
                    border: '1px solid #dddddd',
                    boxShadow: '0px 0px 10px #00000029',
                  }}
                >
                  <Button
                    style={{ width: '100%' }}
                    color="primary"
                    size="large"
                    onClick={() => setAnchorEl(null)}
                  >
                    DONE
                  </Button>
                </ButtonBase>
              )}
            </Card>
          </ClickAwayListener>
        </Popper>
      </div>
    );
  },
  (prevProps, currentProps) =>
    (prevProps.rowState || {})[(prevProps.column || {}).key] ===
      (currentProps.rowState || {})[(currentProps.column || {}).key] &&
    prevProps.delected === currentProps.selected
);

export default DropDownCell;
